const Home = () => {
  window.location.replace('https://www.akouo.io/');
};

export default Home;
